import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import getOfferListKey from 'lib/offer/offerListKey'

interface ExtraItem {
  heading: string
  position: number
  id: string
}

export interface Options {
  disabled?: boolean
}

function useOfferListExtras(filters: App.OfferListFilters | undefined, options: Options = {}): Array<ExtraItem> {
  const { disabled = false } = options

  const listKey = useMemo(() => filters ? getOfferListKey(filters) : '', [filters])

  const extras = useAppSelector(state => state.offer.offerLists[listKey]?.extras ?? [])

  return useMemo(() => {
    if (disabled) {
      return []
    }
    return extras.map((extra): ExtraItem | undefined => {
      switch (extra.type) {
        case 'nearby':
          return {
            id: 'nearby-offers',
            heading: 'Nearby offers',
            position: extra.position,
          }
        case 'you-may-also-like':
          return {
            id: 'you-may-also-like',
            heading: 'You may also like',
            position: extra.position,
          }
        default:
          return undefined
      }
    }).filter((item): item is ExtraItem => item !== undefined)
  }, [disabled, extras])
}

export default useOfferListExtras
